var _path, _circle, _circle2, _circle3, _circle4, _circle5, _rect, _path2, _path3, _path4, _rect2, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDis2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0528 99.9967H54.8957C59.0142 99.9967 62.3528 96.658 62.3528 92.5396V87.7407C62.3528 86.2128 61.8935 84.7134 60.8415 83.6053C58.4869 81.1251 53.4697 76.9463 46.4195 76.9827C39.3813 77.0189 34.4233 81.1541 32.0957 83.6119C31.0504 84.7158 30.5957 86.2081 30.5957 87.7284V92.5396C30.5957 96.658 33.9344 99.9967 38.0528 99.9967Z",
    fill: "#61B06F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.4748,
    cy: 66.5041,
    r: 12.6643,
    fill: "#61B06F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.302,
    cy: 64.8333,
    r: 3.27857,
    fill: "#F1F1F1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.302,
    cy: 64.8333,
    r: 3.27857,
    fill: "#F1F1F1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.259,
    cy: 64.8333,
    r: 3.27857,
    fill: "#F1F1F1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.259,
    cy: 64.8333,
    r: 3.27857,
    fill: "#F1F1F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88.0195,
    y: 83.3086,
    width: 3.81189,
    height: 11.4357,
    transform: "rotate(39.1315 88.0195 83.3086)",
    fill: "#535353"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.888 53.9745L114.024 53.8427L114.94 58.8982L91.7829 86.0362L87.0278 82.1676L108.888 53.9745Z",
    fill: "#C2C0C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3288 97.8682C78.7207 98.1399 78.062 97.6044 78.2041 96.9536L79.3255 91.8165C79.4546 91.2253 80.1617 90.9778 80.6312 91.3596L84.3103 94.3513C84.7798 94.733 84.6817 95.4757 84.1293 95.7226L79.3288 97.8682Z",
    fill: "#89765A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.483 78.8167L90.4025 83.0631L95.9676 88.9741L94.1619 91.1936L87.1295 87.0859L81.6772 81.0362L83.483 78.8167Z",
    fill: "#89765A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 106.65,
    y: 84.6113,
    width: 3.81189,
    height: 11.4357,
    transform: "rotate(-42.2245 106.65 84.6113)",
    fill: "#535353"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7841 59.5717L81.4258 54.4742L86.5615 54.3286L109.911 81.3012L105.372 85.4207L80.7841 59.5717Z",
    fill: "#C2C0C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.739 95.3918C119.916 96.0338 119.288 96.6045 118.666 96.3662L113.756 94.4854C113.191 94.269 113.052 93.5327 113.5 93.126L117.011 89.9383C117.459 89.5315 118.178 89.74 118.339 90.3233L119.739 95.3918Z",
    fill: "#89765A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.528 88.4215L106.766 82.2189L113.446 77.6053L115.369 79.7241L110.251 86.0592L103.451 90.5403L101.528 88.4215Z",
    fill: "#89765A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDis2);
export default __webpack_public_path__ + "static/media/dis-2.54d821da18b2c13a46e2cc5dd086d6d7.svg";
export { ForwardRef as ReactComponent };